<template>
  <el-drawer
    v-model="visible"
    title="使用帮助"
    size="420px"
    :with-header="true"
  >
    <!-- 当前页面对应的帮助 -->
    <div v-if="currentTopic" class="current-topic">
      <div class="topic-tag">当前页面：{{ currentTopic.title }}</div>
      <ol class="topic-steps">
        <li v-for="(s, i) in currentTopic.steps" :key="i">{{ s }}</li>
      </ol>
      <div v-if="currentTopic.links?.length" class="topic-links">
        <el-button
          v-for="l in currentTopic.links"
          :key="l.path"
          type="primary"
          link
          @click="go(l.path)"
        >{{ l.label }} →</el-button>
      </div>
    </div>
    <el-empty v-else description="当前页面暂无专属帮助，可浏览下方全部主题" :image-size="80" />

    <el-divider>全部帮助主题</el-divider>
    <el-collapse v-model="expanded">
      <el-collapse-item
        v-for="t in helpTopics"
        :key="t.match"
        :title="t.title"
        :name="t.match"
      >
        <ol class="topic-steps">
          <li v-for="(s, i) in t.steps" :key="i">{{ s }}</li>
        </ol>
        <div v-if="t.links?.length" class="topic-links">
          <el-button
            v-for="l in t.links"
            :key="l.path"
            type="primary"
            link
            @click="go(l.path)"
          >{{ l.label }} →</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-drawer>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { helpTopics, matchHelpTopic } from '@/config/help-topics'

const visible = ref(false)
const expanded = ref<string[]>([])
const route = useRoute()
const router = useRouter()

const currentTopic = computed(() => matchHelpTopic(route.path))

function open() {
  visible.value = true
}

function go(path: string) {
  visible.value = false
  router.push(path)
}

defineExpose({ open })
</script>

<style scoped lang="scss">
.current-topic {
  .topic-tag {
    font-weight: 600;
    margin-bottom: 12px;
    color: #303133;
  }
}

.topic-steps {
  margin: 0;
  padding-left: 20px;

  li {
    line-height: 1.9;
    color: #606266;
  }
}

.topic-links {
  margin-top: 8px;
}
</style>
